import React from 'react'
import Todo from './component/to-do_app/todo'



const App = () => {
  return (
    <>
      <Todo />
    </>
  )
}

export default App
